export const SIZES = {
  XXXXL: 'XXXXL',
  XXXL: 'XXXL',
  XXL: 'XXL',
  XL: 'XL',
  M: 'M',
  L: 'L',
  S: 'S',
  XS: 'XS',
  XXS: 'XXS',
} as const

export const TEXT_TAGS = {
  DEFAULT: 'p',
  PARAGRAPH: 'p',
  DIV: 'div',
  PRE: 'pre',
  SPAN: 'span',
  SUB: 'sub',
  SUP: 'sup',
} as const

export const HEADING_TAGS = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
  SPAN: 'span',
} as const

export const FONT_FACE = {
  ITALIAN_PLATE: 'ItalianPlate',
  CASH_SANS: 'CashSans',
  CASH_SANS_MONO: 'CashSansMono',
} as const
